<template>
  <div class="home-hero">
    <div class="container home-hero-container">
      <div ref="video" class="home-hero-video">
        <a v-if="videoStatus == 'play'" class="home-hero-video-channel" href="https://www.youtube.com/watch?v=ifV5bG5dsUM" target="_blank"></a>
        <video-player
          url="https://www.youtube.com/embed/ifV5bG5dsUM?modestbranding=1&autohide=1&showinfo=0&controls=0"
          @on-play="videoChange('play')"
          @on-pause="videoChange('pause')"
          @on-end="videoChange('end')" />
      </div>

      <div v-show="videoStatus != 'play'" class="home-hero-description">
        <h1 class="home-hero-title">
          Descubra o
          <img alt="lado B" src="@/assets/images/lado-b.png" />
          dos impostos que você paga
        </h1>
        <p>
          <span>Entenda o papel social dos impostos e </span>
          <span>porque uma reforma tributária justa é </span>
          <span>fundamental para reduzir as </span>
          desigualdades brasileiras.
        </p>
      </div>

      <div ref="scrollDown" v-show="videoStatus != 'play'" :class="['home-hero-scroll', {'home-hero-scroll--fixed': fixedButton}]" @click="scrollDown">
        <svg>
          <use xlink:href="#icon-arrow-down" />
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
import Video from '@/components/Video.vue';

export default {
  data() {
    return {
      videoStatus: 'pause',
      fixedButton: true
    };
  },
  mounted() {
    window.addEventListener('scroll', this.onScroll);
  },
  destroyed() {
    window.removeEventListener('scroll', this.onScroll);
  },
  components: {
    'video-player': Video,
  },
  methods: {
    onScroll() {
      const { video, scrollDown  } = this.$refs;

      const videoBounds = video.getBoundingClientRect();
      const buttonBounds = scrollDown.getBoundingClientRect();

      const limitVideo = videoBounds.y + videoBounds.height;
      const limitButton = window.innerHeight - 118;

      this.fixedButton = (limitVideo > limitButton) ? true : false ;
    },
    videoChange(status) {
      this.videoStatus = status;
    },
    scrollDown() {
      window.scrollBy({
        top: window.innerHeight,
        left: 0,
        behavior: 'smooth',
      });
    },
  },
};
</script>

<style lang="scss">
.home-hero {
  position: relative;

  display: flex;
  justify-content: center;
  align-items: center;

  width: 100%;
  background-color: $minsk;

  @media screen and (min-width: rem-calc(984)) {
    min-height: calc(100vh - #{$header-height} - #{$footer-height});
  }

  @media #{$medium-up} {
    padding: 30px 0 100px;
  }
}

.home-hero-container {
  position: relative;

  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: rem-calc(50);

  width: 100%;
  max-width: rem-calc(1155);

  @media screen and (min-width: rem-calc(984)) {
    flex-direction: row;
    padding-bottom: 0;
  }
}

.home-hero-video {
  display: flex;
  align-items: center;

  width: 100%;
  height: auto;

  flex-shrink: 0;

  @media screen and (min-width: rem-calc(984)) {
    padding-top: 0;
    height: rem-calc(440);
    max-width: rem-calc(785);
  }
}

.home-hero-video-channel {
  position: absolute;
  top: rem-calc(12);
  left: rem-calc(35);
  right: rem-calc(35);

  width: auto;
  height: rem-calc(40);

  z-index: 5;

  @media screen and (min-width: rem-calc(385)) {
    width: rem-calc(285);
    
    right: inherit;
  }
}

.home-hero-title {
  color: $white;
  font-size: rem-calc(18);
  font-family: $font-family--header;

  @media #{$medium-up} {
    font-size: rem-calc(34);
  }
}

.home-hero-description {
  position: relative;

  width: 100%;
  max-width: rem-calc(285);

  margin-top: rem-calc(-35);

  color: $white;

  z-index: 5;

  @media #{$medium-up} {
    max-width: rem-calc(550);

    margin-top: 0;
  }

  @media screen and (min-width: rem-calc(984)) {
    position: absolute;
    top: 50%;
    right: rem-calc(25);

    transform: translate(0, -50%);
  }

  img {
    width: 100%;
  }

  p {
    margin-left: auto;

    font-size: rem-calc(12);
    line-height: rem-calc(16);

    @media screen and (min-width: rem-calc(984)) {
      max-width: rem-calc(290);
    }

    @media #{$medium-up} {
      font-size: rem-calc(16);
      line-height: rem-calc(24);
    }
  }
}

.home-hero-scroll {
  position: absolute;
  bottom: 0;
  left: 50%;

  display: flex;
  justify-content: center;
  align-items: center;

  width: rem-calc(55);
  height: rem-calc(55);

  z-index: 5;
  cursor: pointer;
  overflow: hidden;
  border-radius: 100%;
  background-color: $turmeric;
  transform: translate(-50%, 50%);

  @media #{$medium-up} {
    width: rem-calc(80);
    height: rem-calc(80);
  }

  @media screen and (max-height: rem-calc(683)) and (min-width: rem-calc(984)) {
    &.home-hero-scroll--fixed {
      position: fixed;
      bottom: rem-calc(170);
    }
  }

  &:hover {
    svg {
      animation: arrowDown 4s ease infinite;
    }
  }

  svg {
    width: 60%;
    height: 60%;

    animation: arrowBlink 2s ease infinite;
  }
}

@keyframes arrowDown {
  0% {
    opacity: 0;
    transform: translate(0, -50%);
  }

  50% {
    opacity: 1;
    transform: translate(0, 0);
  }

  100% {
    opacity: 0;
    transform: translate(0, 50%);
  }
}

@keyframes arrowBlink {
  0% {
    opacity: 0.5;
  }

  50% {
    opacity: 1;
  }

  100% {
    opacity: 0.5;
  }
}
</style>
